// Разбор ошибок API. Ошибка может прийти в двух видах:
//  - AxiosError (прямые запросы axios): тело ответа лежит в err.response.data;
//  - ApiException из сгенерированного apiClient: тело ответа лежит в err.response (уже разобранное или строкой).
// Сервер отвечает JSON-ом вида { message, field?, expired?, codeExpired? }.

export interface ApiErrorInfo {
  status?: number;
  message?: string;
  /** Поле формы, к которому относится ошибка (например, "email"). */
  field?: string;
  /** Заявка на регистрацию устарела — форму нужно заполнить заново. */
  expired?: boolean;
  /** Код больше не действует — нужно запросить новый. */
  codeExpired?: boolean;
}

export function parseApiError(err: any): ApiErrorInfo {
  let data = err?.response?.data ?? err?.response ?? err?.result;
  if (typeof data === 'string') {
    try {
      data = JSON.parse(data);
    } catch {
      data = undefined;
    }
  }

  const info: ApiErrorInfo = { status: err?.status ?? err?.response?.status };
  if (data && typeof data === 'object') {
    if (typeof data.message === 'string') info.message = data.message;
    if (typeof data.field === 'string') info.field = data.field;
    info.expired = data.expired === true;
    info.codeExpired = data.codeExpired === true;
  }
  return info;
}
